import React from 'react';
import { cartClass } from '@/react/data';
import CalcCartHead from '@/react/temps/CalcCartHead';
import CalcCartFoot from '@/react/temps/CalcCartFoot';
import { useCartContext } from '@/react/store/context';
import CalcCartRow from '@/react/temps/CalcCartRow';
const IsHasAirduct = true;
const CalcCartTable = () => {
    const [{ cart }] = useCartContext();
    return (React.createElement("div", { className: `${cartClass}__wrapper` },
        React.createElement("table", { className: cartClass, style: { tableLayout: 'fixed' } },
            React.createElement(CalcCartHead, null),
            React.createElement("tbody", { className: `${cartClass}__body` }, cart.map((item, i) => (React.createElement(CalcCartRow, { item: item, index: i, isMontage: item.type === 'montage', key: i })))),
            React.createElement(CalcCartFoot, null))));
};
export default CalcCartTable;
